module.exports = __webpack_public_path__ + "img/appAsset-brand--GoogleLogo.7cdae05c.svg";